import React from 'react';
import AppContainer from '../app-container';
import * as partnerActions from '../../actions/partners';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import LocalizedStrings from '../../localization/strings';
import Loading from '../../components/loading';
import DocumentTitle from 'react-document-title';
import PartnersDisplay from '../../components/partner/partners-display';

class HomeContainer extends AppContainer {

    componentWillMount() {
        this.props.actions.fetchAllPartners();
    }

    renderPartners() {

        return <PartnersDisplay partners={this.props.partners.items}/>
    }

    render() {
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.partners)}>

                <div className="page-section">
                    <div className="container">
                        <h1 className="title">
                            <span>{LocalizedStrings.partners}</span>
                        </h1>
                        {this.props.partners.loading
                            ? <Loading/>
                            : this.renderPartners()}
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}

export default connect(function (state) {
    return {partners: state.partner.partners};
}, function (dispatch) {
    return {
        actions: bindActionCreators({
            ...partnerActions
        }, dispatch)
    };
})(HomeContainer);



// WEBPACK FOOTER //
// ./src/js/containers/pages/partners-page-container.js